import Layout from '@/layout';
export default {
  path: '/material-center',
  component: Layout,
  redirect: '/material-center/list',
  name: 'MaterialCenterRoot',
  meta: {
    title: '素材中心',
    icon: 'collection'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/material-center/index');
    },
    name: 'MaterialCenter',
    meta: {
      title: '素材中心',
      icon: 'collection'
    }
  }]
};